import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '../leaflet-rotatedmarker';

// 自定义飞机图标
const planeIcon = new L.Icon({
    iconUrl: require('../plane4-45.png'), // 替换为您的飞机图标路径
    iconSize: [40, 40], // 图标的大小
    iconAnchor: [20, 20], // 图标的中心点
    popupAnchor: [0, -20], // 弹出窗口相对于图标的位置
});

const FlightMap = ({planes}) => {

    const position = [43.70011, -79.4163]; // Initial map position
  
    return (
      <MapContainer center={position} zoom={6} style={{ height: '100vh', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {planes.map((plane) => (
          <Marker
          
                key={plane[0]}
                position={[plane[6], plane[5]]}
                icon={planeIcon}
                rotationAngle={plane[10]} 
                >
          <Popup>
            <div>Flight: {plane[1]}</div> 
            <div>Country: {plane[2]}</div> 
            <div>Longitude: {plane[5]}</div> 
            <div>Latitude: {plane[6]}</div> 
          </Popup>
          </Marker>
        ))}
      </MapContainer>
    );
  };

export default FlightMap;
